module.exports = __webpack_public_path__ + "static/media/banner-api-mobile.73a6a561.png";